import { ArrowLeft } from '@untitled-ui/icons-react/build/cjs';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import ErrorMsg from 'src/components/errorMsg';

import ButtonCmp from '../../components/ButtonCmp';
import InputText from '../../components/InputText/InputText';
import { sendOtp } from '../../services/AuthService';
import './login.scss';
import AuthWrapper from '../AppLayout/AuthWrapper';

import VerifyOtp from './VerifyOtp';

const initValidForm = {
    email: true,
    isEmailValid: true,
};

const ForgotPassword = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [validForm, setValidForm] = useState(initValidForm);
    const [showVerification, setShowVerification] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const initFormData: any = {
        email: location.state?.email || '',
    };

    const [formData, setFormData] = useState<any>(initFormData);
    const [errorMsg, setErrorMsg] = useState<any>('');

    useEffect(() => {
        if (location.state?.email) {
            setFormData((prevFormData: any) => ({
                ...prevFormData,
                email: location.state.email,
            }));
        }
    }, [location.state]);

    const valid = () => {
        let isValid = true;
        const validFormData = {
            email: true,
            isEmailValid: true,
            otp: true,
        };
        const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}/g;

        if (formData.email === '' || formData.email === null) {
            validFormData.email = false;
            isValid = false;
        }

        if (formData.email && !emailRegex.test(formData.email)) {
            validFormData.isEmailValid = false;
            isValid = false;
        }

        setValidForm({ ...validForm, ...validFormData });

        return isValid;
    };

    const handleInputChange = (event: any) => {
        setErrorMsg('');
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    const handleSubmit = (event: any) => {
        setErrorMsg('');
        event.preventDefault();

        if (!valid()) {
            return true;
        }
        setIsLoading(true);
        sendOtp(formData)
            .then((response) => {
                setIsLoading(false);

                if (response?.code) {
                    setShowVerification(true);
                } else {
                    setErrorMsg(response?.message || t('Auth.Error.Something_Went_Wrong'));
                }
            })
            .catch((error): any => {
                setIsLoading(false);
                setErrorMsg(error?.response?.data?.message || t('Auth.Error.Something_Went_Wrong'));
            });
    };

    return (
        <>
            {!showVerification ? (
                <AuthWrapper authHeading={t('Auth.Forgot_Password')} authSubTitle={t('Auth.Forgot_Password_Subtitle')}>
                    <form onSubmit={handleSubmit} className="flex flex-col gap-y-5">
                        <div>
                            <InputText
                                label={t('Auth.Email')}
                                labelClassName="block mb-1.5"
                                inputName="email"
                                size="md"
                                className={`${!validForm.email || !validForm?.isEmailValid || errorMsg ? ' !border-[#FDA29B] ' : ' !border-[#D0D5DD] '} btn-custom-lg`}
                                placeholder={t('Auth.Enter_Email')}
                                value={formData.email}
                                onChangeFunc={handleInputChange}
                                errorText={''}
                            />
                            <ErrorMsg errorText={errorMsg} />
                        </div>
                        <ButtonCmp
                            type="submit"
                            size="lg"
                            disabled={isLoading || !formData.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)}
                            className="btn_primary_black w-full"
                            loading={isLoading}
                        >
                            {t('Auth.Continue')}
                        </ButtonCmp>

                        <div className="text-center">
                            <Link to="/login" className="text-grayLight600 gap-x-1.5 cursor-pointer inline-flex items-center justify-center">
                                <ArrowLeft className="w-4 h-4 object-contain text-grayLight600" />
                                <span className="text-grayLight600 text-[12px] leading-[18px] font-semibold">{t('Auth.Verify_Email.Back_To_Login')}</span>
                            </Link>
                        </div>
                    </form>
                </AuthWrapper>
            ) : (
                <VerifyOtp email={formData?.email} />
            )}
        </>
    );
};

export default ForgotPassword;
